import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ADGMPanel, ADGMGridLayoutV2 } from 'aurora-components';

const UAEResidentBuyerPanelDetails = ({ classes, locale, buyer }) => {
  const transformedBuyerDetails = useMemo(
    () => [
      {
        label: 'Name',
        value: locale === 'en' ? buyer?.nameEn || buyer?.nameAr : buyer?.nameAr || buyer?.nameEn,
        isPersonName: true,
      },
      {
        label: 'trade_license_number',
        value: buyer?.tradeLicense,
      },
      {
        label: 'Phone_Number',
        value: <bdi>{buyer?.phoneNumber ?? '-'}</bdi>,
      },
      {
        label: 'email',
        value: buyer?.email,
      },
    ],
    [buyer],
  );

  return (
    <ADGMPanel title='party_details' customClasses={{ container: classes.detailsPanel }}>
      <ADGMGridLayoutV2
        gridData={transformedBuyerDetails}
        withIcon
        customClasses={{ container: classes.gridContainer }}
      />
    </ADGMPanel>
  );
};

UAEResidentBuyerPanelDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  buyer: PropTypes.object.isRequired,
};

export default UAEResidentBuyerPanelDetails;
